import { styled } from "simplydo/react/styled";

import { useCurrentUser } from "utils/currentUser";

import NotificationTray from "components/lib/Notifications";

const NotificationsContainer = styled.div`
  background-color: #fff;
  padding: 1rem;
`;

const MobileNotificationsWidget = () => {
  const user = useCurrentUser();

  if (!user) return null;
  return (
    <NotificationsContainer>
      <NotificationTray isMobile />
    </NotificationsContainer>
  );
};

export default MobileNotificationsWidget;
